import React from 'react';

const Detail = ({ detail, detailShown, toggleDetail }) => {
	if (detailShown) {
		return (
			<div className={`${detailShown}Overlay`} onClick={toggleDetail}>
				<aside className='detail'>
					<button className='close' onClick={toggleDetail}>
						X
					</button>
					<h3>Product Detail</h3>
					<p>{detail}</p>
				</aside>
			</div>
		);
	} else {
		return <div className='hiddenDetail'></div>;
	}
};
export default Detail;
